<template>
  <div class="pd20x flex1">
    <div class="contentBox h100pct ofA">
      <div class="filter" style="padding:10px 20px; display: flex; justify-content: space-between; align-items: center;">
        <div style="display: flex; gap: 10px; align-items: center; flex-wrap: wrap;">
          <label>搜索：</label>
          <a-input-search
            v-model="filter.content"
            placeholder="搜索级别/乐器"
            style="width: 180px"
            @search="searchData"
            class="mr10px"
          />
          <label>报考类别：</label>
          <a-select v-model="filter.exam_type" style="width: 140px" placeholder="全部类别" @change="searchData" allowClear>
            <a-select-option :value="1">线上乐理</a-select-option>
            <a-select-option :value="2">线上演奏</a-select-option>
          </a-select>
          <label>状态：</label>
          <a-select v-model="filter.status" style="width: 100px" placeholder="全部状态" @change="searchData" allowClear>
            <a-select-option :value="1">启用中</a-select-option>
            <a-select-option :value="0">已禁用</a-select-option>
          </a-select>
        </div>
        <div>
          <a-button type="primary" icon="plus" @click="showAddModal">新增科目价格配置</a-button>
        </div>
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        rowKey="id"
        @change="changePage"
      >
        <template slot="exam_type" slot-scope="text">
          <a-tag :color="text === 1 ? 'blue' : 'green'">
            {{ text === 1 ? '线上乐理 / Theory' : '线上演奏 / Practical' }}
          </a-tag>
        </template>
        <template slot="instrument" slot-scope="text, record">
          <span>{{ record.exam_type === 1 ? 'Music Theory (无)' : (text || '-') }}</span>
        </template>
        <template slot="original_price" slot-scope="text">
          <span style="text-decoration: line-through; color: #999;">￥{{ parseFloat(text).toFixed(2) }}</span>
        </template>
        <template slot="platform_price" slot-scope="text">
          <span style="font-weight: bold; color: #ff5252;">￥{{ parseFloat(text).toFixed(2) }}</span>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-switch :checked="text === 1" @change="toggleStatus(record)" checked-children="开" un-checked-children="关" />
        </template>
        <template slot="addtime" slot-scope="text">
          <span>{{ text > 0 ? formatDate(text * 1000) : '-' }}</span>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="showEditModal(record)" style="margin-right: 15px;">编辑</a>
          <a-popconfirm
            title="确定要删除这个科目价格配置吗？"
            ok-text="确认"
            cancel-text="取消"
            @confirm="deleteItem(record.id)"
          >
            <a href="javascript:;" style="color: red;">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </div>

    <!-- 新增 / 编辑 价格类目弹窗 -->
    <a-modal
      :title="isEdit ? '编辑科目价格配置' : '新增科目价格配置'"
      :visible="modalVisible"
      :confirm-loading="submitLoading"
      @ok="handleSubmit"
      @cancel="modalVisible = false"
      okText="提交"
      cancelText="取消"
      width="550px"
    >
      <a-form-model :model="form" ref="categoryForm" :rules="rules" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
        <a-form-model-item label="报考类型" prop="exam_type">
          <a-select v-model="form.exam_type" placeholder="请选择类别" @change="handleTypeChange">
            <a-select-option :value="1">线上乐理</a-select-option>
            <a-select-option :value="2">线上演奏</a-select-option>
          </a-select>
        </a-form-model-item>
        
        <a-form-model-item v-if="form.exam_type === 2" label="报考乐器" prop="instrument">
          <a-input v-model="form.instrument" placeholder="请输入乐器名称，如：钢琴" />
        </a-form-model-item>

        <a-form-model-item label="报考级别" prop="exam_level">
          <a-input v-model="form.exam_level" placeholder="如：Grade 5 或 5级" />
        </a-form-model-item>

        <a-form-model-item label="官方原价 (￥)" prop="original_price">
          <a-input-number v-model="form.original_price" :min="0" :precision="2" style="width: 100%" placeholder="请输入官方参考原价" />
        </a-form-model-item>

        <a-form-model-item label="平台特惠价 (￥)" prop="platform_price">
          <a-input-number v-model="form.platform_price" :min="0" :precision="2" style="width: 100%" placeholder="请输入平台代报优惠价格" />
        </a-form-model-item>

        <a-form-model-item label="启用状态" prop="status">
          <a-radio-group v-model="form.status">
            <a-radio :value="1">启用</a-radio>
            <a-radio :value="0">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="描述说明" prop="description">
          <a-textarea v-model="form.description" :rows="3" placeholder="请输入描述性文字，如报考要求、注意事项等" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import * as http from '@/libs/examapi'
import { formatDate } from '@/libs/moment'

const columns = [
  {
    title: '科目类别',
    dataIndex: 'exam_type',
    scopedSlots: { customRender: 'exam_type' },
    align: 'center',
    width: 150
  },
  {
    title: '乐器',
    dataIndex: 'instrument',
    scopedSlots: { customRender: 'instrument' },
    align: 'center'
  },
  {
    title: '级别',
    dataIndex: 'exam_level',
    align: 'center'
  },
  {
    title: '官方原价',
    dataIndex: 'original_price',
    scopedSlots: { customRender: 'original_price' },
    align: 'center'
  },
  {
    title: '平台代报价格',
    dataIndex: 'platform_price',
    scopedSlots: { customRender: 'platform_price' },
    align: 'center'
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    align: 'center',
    width: 100
  },
  {
    title: '创建时间',
    dataIndex: 'addtime',
    scopedSlots: { customRender: 'addtime' },
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
    width: 150
  }
]

export default {
  name: 'ExamCategoryList',
  data () {
    return {
      columns,
      data: [],
      loading: false,
      filter: {
        content: '',
        exam_type: undefined,
        status: undefined
      },
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        showTotal: total => `共 ${total} 条`
      },
      modalVisible: false,
      submitLoading: false,
      isEdit: false,
      form: {
        id: undefined,
        exam_type: 1,
        instrument: '',
        exam_level: '',
        original_price: undefined,
        platform_price: undefined,
        status: 1,
        description: ''
      },
      rules: {
        exam_type: [{ required: true, message: '请选择报考类别', trigger: 'change' }],
        instrument: [{ required: true, message: '请输入乐器名称', trigger: 'blur' }],
        exam_level: [{ required: true, message: '请输入报考级别', trigger: 'blur' }],
        original_price: [{ required: true, message: '请输入官方参考原价', trigger: 'blur' }],
        platform_price: [{ required: true, message: '请输入平台代报价格', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    formatDate,
    getData () {
      this.loading = true
      const params = {
        page: this.pagination.current,
        size: this.pagination.pageSize,
        content: this.filter.content,
        exam_type: this.filter.exam_type,
        status: this.filter.status
      }
      http.getExamCategoryList(params).then(res => {
        this.loading = false
        if (res && res.list) {
          this.data = res.list
          this.pagination.total = res.count
        } else {
          this.$message.error('获取列表失败')
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('系统繁忙，获取列表失败')
      })
    },
    searchData () {
      this.pagination.current = 1
      this.getData()
    },
    changePage (pagination) {
      this.pagination.current = pagination.current
      this.getData()
    },
    handleTypeChange (val) {
      if (val === 1) {
        this.form.instrument = ''
      }
    },
    showAddModal () {
      this.isEdit = false
      this.form = {
        id: undefined,
        exam_type: 1,
        instrument: '',
        exam_level: '',
        original_price: undefined,
        platform_price: undefined,
        status: 1,
        description: ''
      }
      this.modalVisible = true
      this.$nextTick(() => {
        if (this.$refs.categoryForm) {
          this.$refs.categoryForm.clearValidate()
        }
      })
    },
    showEditModal (record) {
      this.isEdit = true
      this.form = {
        id: record.id,
        exam_type: record.exam_type,
        instrument: record.instrument,
        exam_level: record.exam_level,
        original_price: parseFloat(record.original_price),
        platform_price: parseFloat(record.platform_price),
        status: record.status,
        description: record.description
      }
      this.modalVisible = true
      this.$nextTick(() => {
        if (this.$refs.categoryForm) {
          this.$refs.categoryForm.clearValidate()
        }
      })
    },
    handleSubmit () {
      this.$refs.categoryForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        
        const apiName = this.isEdit ? 'updateExamCategory' : 'addExamCategory'
        http[apiName](this.form).then(res => {
          this.submitLoading = false
          if (res !== undefined) {
            this.$message.success(this.isEdit ? '修改成功' : '新增配置成功')
            this.modalVisible = false
            this.getData()
          }
        }).catch(() => {
          this.submitLoading = false
          this.$message.error('系统繁忙，操作失败')
        })
      })
    },
    toggleStatus (record) {
      const nextStatus = record.status === 1 ? 0 : 1
      http.updateExamCategory({ id: record.id, status: nextStatus }).then(res => {
        if (res !== undefined) {
          this.$message.success('状态变更成功')
          this.getData()
        }
      }).catch(() => {
        this.$message.error('操作异常')
      })
    },
    deleteItem (id) {
      http.delExamCategory({ id }).then(res => {
        if (res !== undefined) {
          this.$message.success('删除成功')
          this.getData()
        }
      }).catch(() => {
        this.$message.error('删除异常')
      })
    }
  }
}
</script>

<style scoped>
.pd20x {
  padding: 20px;
}
.flex1 {
  flex: 1;
}
.contentBox {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.h100pct {
  height: 100%;
}
.ofA {
  overflow: auto;
}
.filter {
  border-bottom: 1px solid #f0f0f0;
}
.mr10px {
  margin-right: 10px;
}
</style>
